<template>
    <div style="width:100%">
        <v-snackbar
                v-model="snackbars['password'].enabled"
                color="primary"
                :timeout="2000"
                :top="true">
            {{snackbars['password'].label}}
        </v-snackbar>
        <v-snackbar
                v-model="snackbars['update'].enabled"
                color="primary"
                :timeout="2000"
                :top="true">
            {{snackbars['update'].label}}
        </v-snackbar>
        <v-form v-model="valid" style="width:100%" ref="userProfileForm" @submit="save" onsubmit="return false">
            <v-container fluid>
                <v-layout row wrap>
                    <v-flex md3>
                        <v-text-field label="E-Mail (User Name)"
                                      v-model="user.email"
                                      counter="100"
                                      :disabled="true"></v-text-field>
                    </v-flex>
                </v-layout>
                <v-layout row wrap>
                    <v-flex md3>
                        <v-text-field counter="100" label="First Name" v-model="user.firstName" :rules="serverValidation('firstName','First Name')"></v-text-field>
                    </v-flex>
                    <v-flex md3>
                        <v-text-field counter="100" label="Middle Name" v-model="user.middleName"></v-text-field>
                    </v-flex>
                    <v-flex md3>
                        <v-text-field counter="100" label="Last Name" v-model="user.lastName" :rules="serverValidation('lastName','Last Name')"></v-text-field>
                    </v-flex>
                </v-layout>

                <v-layout row wrap>
                    <v-flex md3>
                        <v-text-field counter="100" label="Alias" v-model="user.alias"></v-text-field>
                    </v-flex>
                    <v-flex md3>
                        <v-text-field label="Phone Number" v-model="user.phoneNumber"
                                      v-mask="'(###) ### - ####'"></v-text-field>
                    </v-flex>

                </v-layout>
                <v-layout row wrap>
                    <v-flex md3>
                        <v-text-field readonly="readonly"
                                      label="Organization"
                                      type="text"
                                      disabled="disabled"
                                      v-model="organization.name"></v-text-field>
                    </v-flex>
                </v-layout>
                <v-layout row wrap>
                    <v-btn outlined class="mx-2" type="button" @click="goBack()"  color="warning"  dark>Go Back</v-btn>
                    <v-btn outlined class="mx-2" type="button" @click="resetPassword()"  color="info" :disabled="overlay" dark>Reset Password</v-btn>
                    <v-btn outlined class="mx-2" type="button" @click="save()" color="success" :disabled="overlay">Save</v-btn>
                    <v-progress-circular
                            :width="3"
                            v-show="overlay"
                            color="red"
                            indeterminate="">
                    </v-progress-circular>
                </v-layout>
            </v-container>
        </v-form>
        <v-dialog v-model="resetPasswordDialog" persistent max-width="400">
            <v-card>
                <v-form ref="userResetPasswordForm" @submit="doResetPassword()" onsubmit="return false">
                    <v-card-title>
                        <span class="headline">Reset Password</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container grid-list-md>
                            <v-layout wrap>
                                <v-flex md12>
                                    <v-text-field v-model="newPassword" :rules="serverValidation('resetPassword.password','Password')" type="password" label="Password" required></v-text-field>
                                </v-flex>
                                <v-flex md12>
                                    <v-text-field v-model="confirmNewPassword"  type="password" label="Confirm Password" required></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn outlined class="mx-2" type="button" color="warning" flat @click="closeResetPasswordDialog()" :disabled="passwordOverlay">Cancel</v-btn>
                        <v-btn outlined class="mx-2" type="submit" color="green darken-1" flat @click="doResetPassword()" :disabled="passwordOverlay">Reset</v-btn>
                        <v-progress-circular
                                :width="3"
                                v-show="passwordOverlay"
                                color="red"
                                indeterminate="">
                        </v-progress-circular>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import {validationMixin} from '@/mixins/validations'
    import api from '@/api';
    export default {
        mixins: [validationMixin],
        inject : ['getUserProfile','getUserProfileOrganization'],
        data() {
            return {
                valid: true,
                snackbars: {
                    'password':{'enabled':false,'label':'Password Updated'},
                    'update':{'enabled':false,'label':'User Profile Updated'}
                },
                user: {},
                organization: {},
                resetPasswordDialog: false,
                newPassword:null,
                overlay:false,
                passwordOverlay:false,
                confirmNewPassword:null
            }
        },
        created() {
            this.user = this.getUserProfile();
            this.organization = this.getUserProfileOrganization()
        },
        methods: {
            save() {
                this.overlay = true;
                api.userProfile.patch(this.user).then((user) => {
                    this.user = user;
                    this.snackbars['update'].enabled = true;
                },(error) => {
                    if (this.processErrors(error) == this.RESPONSE_VALIDATION) {
                        this.$refs.userProfileForm.validate();
                    }
                }).finally(() => {
                    this.overlay = false;
                });
            },
            goBack() {
                this.$router.go(-1);
            },
            resetPassword : function() {
                this.resetPasswordDialog = true;
            },
            closeResetPasswordDialog() {
                this.resetPasswordDialog = false;
                this.violations = [];
                this.newPassword = '';
                this.confirmNewPassword = '';
                this.passwordOverlay = false;
            },
            doResetPassword : function() {
                if (!this.newPassword || !this.confirmNewPassword || this.newPassword != this.confirmNewPassword) {
                    this.$root.$emit('globalError','Passwords Do Not Match');
                    return;
                }
                this.passwordOverlay = true;
                api.userProfile.password.post(this.user.id,this.newPassword).then(() => {
                    this.resetPasswordDialog=false;
                    this.$root.$emit('globalMessage','Password Updated');
                    this.newPassword = '';
                    this.confirmNewPassword = '';
                },(error) => {
                    if (this.processErrors(error) == this.RESPONSE_VALIDATION) {
                        this.$refs.userResetPasswordForm.validate();
                    }
                }).finally(() => {
                    this.passwordOverlay = false;
                });
            }
        }
    }
</script>